const convertWindBearing = (bearing, granularity) => {
	const rounded = granularity * Math.round(bearing / granularity);
	switch (rounded) {
		case 0:
		case 360:
			return 'N';
		case 22.5:
			return 'NNE';
		case 45:
			return 'NE';
		case 67.5:
			return 'ENE';
		case 90:
			return 'E';
		case 112.5:
			return 'ESE';
		case 135:
			return 'SE';
		case 157.5:
			return 'SSE';
		case 180:
			return 'S';
		case 202.5:
			return 'SSW';
		case 225:
			return 'SW';
		case 247.5:
			return 'WSW';
		case 270:
			return 'W';
		case 292.5:
			return 'WNW';
		case 315:
			return 'NW';
		case 337.5:
			return 'NNW';
	}
};

export const convertWindBearing8 = bearing => convertWindBearing(bearing, 45);
export const convertWindBearing16 = bearing => convertWindBearing(bearing, 22.5);



// WEBPACK FOOTER //
// ./utils/convert-wind-bearing.js